export default [
  {
    path: '/client/auth',
    name: 'client-auth',
    component: () => import('../views/client/auth.vue')
  }
]
